import FieldError from "./FieldError";

type TextAreaProps = {
  error?: string;
  label: string;
  onBlur?: () => void;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  value: string;
};

export default function TextArea({
  error,
  label,
  onBlur,
  onChange,
  placeholder,
  required = false,
  value,
}: TextAreaProps) {
  return (
    <label className="mt-6 block">
      <span className="field-label">{label}</span>
      <textarea
        className="field-input min-h-28"
        onBlur={onBlur}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        required={required}
        value={value}
      />
      <FieldError error={error} />
    </label>
  );
}
